module.exports = __webpack_public_path__ + "assets/modal-frags-coin-fca0f186.png";